var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 17 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12.0363 18L8.26133 12.125L4.83633 18H0.886328L6.38633 9.2L0.811328 0.55H4.83633L8.61133 6.4L12.0113 0.55H15.9613L10.4863 9.325L16.0613 18H12.0363Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }